import React from 'react';
import RegisterPage from '../../shared/components/RegisterPage';

const UserRegisterPage = () => {
    // This component renders the shared RegisterPage for users.
    return <RegisterPage />;
};

export default UserRegisterPage;
